import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SeoService } from '../../seo.services';

@Component({
  selector: 'app-colitis',
  templateUrl: './colitis.component.html',
  styleUrls: []
})
export class ColitisComponent implements OnInit {

    constructor(private title: Title, private seo: SeoService) { }

  ngOnInit() {
  	let t:string ="¿Colitis? Te presentamos la nueva presentación de Sinuberase";
  	this.title.setTitle(t);

  	this.seo.generateTags({
  		title:"¿Colitis? Te presentamos la nueva presentación de Sinuberase",
  		description: "¿Colitis? Te recomendamos probar la nueva presentación de Sinuberase. Contiene probióticos que ayudan a aliviar dolor, inflamación y diarrea desde la raíz",
  		slug: "Colitis"
  	})

  	this.seo.closeMenu();
  }

}
